import { useEffect } from 'react'
import { useLocation } from '@reach/router'

// @reach/router updates window.history (and therefore location) before
// re-rendering, so location.pathname here is always the committed route -
// unlike GA4's built-in history-change listener, which can read the URL
// before this app's title/content has caught up.
function GAListener() {
  const location = useLocation()

  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
    })
  }, [location.pathname, location.search])

  return null
}

export default GAListener
